/**
 * @generated SignedSource<<e092cd0541bec6475f1125fc2a45687d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoEditTimelineDeleteCommentMutation$variables = {
  commentId: string;
};
export type TodoEditTimelineDeleteCommentMutation$data = {
  readonly todoComment: {
    readonly delete: {
      readonly id: string;
    } | null;
  };
};
export type TodoEditTimelineDeleteCommentMutation = {
  response: TodoEditTimelineDeleteCommentMutation$data;
  variables: TodoEditTimelineDeleteCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "commentId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditTimelineDeleteCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoCommentMutation",
        "kind": "LinkedField",
        "name": "todoComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoComment",
            "kind": "LinkedField",
            "name": "delete",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoEditTimelineDeleteCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoCommentMutation",
        "kind": "LinkedField",
        "name": "todoComment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoComment",
            "kind": "LinkedField",
            "name": "delete",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2e15c2c5cd981a1f172cfb0c9cc39b41",
    "id": null,
    "metadata": {},
    "name": "TodoEditTimelineDeleteCommentMutation",
    "operationKind": "mutation",
    "text": "mutation TodoEditTimelineDeleteCommentMutation(\n  $commentId: ID!\n) {\n  todoComment(id: $commentId) {\n    delete {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc0b7a456fec837596a503405d079ef3";

export default node;
